import { createApp, setup } from '@shared/setup'

import Router from '@shared/modules/Dvp/Router'
import TheRoot from '@shared/components/Container/TheRoot'

import { APP } from '@shared/config/constants'

window._appName = APP.DVP.name
window._appGroup = APP.DVP.group
const element = document.getElementById('configurator')

const props = element.dataset

const app = await setup({
  appInstance: createApp(TheRoot, props),
  appName: window._appName,
})
app.use(Router)
app.mount(element)
